import { Input } from "antd";
import { observer } from "mobx-react-lite";
import { Controller, FieldValues, Path, UseFormReturn } from "react-hook-form";

interface Props<FV extends FieldValues> {
  form: UseFormReturn<FV>;
  path: Path<FV>;
  placeholder: string;
}

export const FormTextArea = observer(
  <FV extends FieldValues>({ form, path, placeholder }: Props<FV>) => {
    return (
      <Controller
        control={form.control}
        name={path}
        render={({ field }) => (
          <Input.TextArea {...field} placeholder={placeholder} />
        )}
      />
    );
  },
);
